import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface IStaffProfile extends IEntity {
  attributes: {
    id: EntityStringId;
    staffName: string;
  };
}

export type StaffProfile = Entity<IStaffProfile>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffProfile: IEntityType<IStaffProfile> = vmClient.defineClass({
  typeName: 'StaffProfile',
  version: 2,
  persisted: true,

  attributes: {
    staffName: {
      type: 'string',
      notNull: true,
    },
  },
});
